//获取LocalStorage
export function getLocalStorageTime(key, _this) {
  // console.log(localStorage.getItem(key));
  var exp = 60 * 60 * 12 * 1000; // 十二小时的毫秒数
  if (localStorage.getItem(key) != "undefined") {
    var vals = localStorage.getItem(key); // 获取本地存储的值 
    var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
    // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间 
    var isTimed = (new Date().getTime() - dataObj) > exp;
    // console.log(isTimed)
    if (isTimed) {
      localStorage.removeItem(key);
      _this.$router.push({
        name: "login"
      });
    } else {
      _this.$router.push({
        name: "index"
      });
    }
  }
}

//获取LocalStorage
export function getLocalStorage(key) {
  var vals = localStorage.getItem(key);
  return vals;
}

//跳转页面
export function JumpPage(key, _this) {
  _this.$router.push({
    name: key
  });
}
//跳转页面带参数
export function JumpPageByParams(key,data, _this) {
  _this.$router.push({
    name: key, 
    params: data
  });
}

//判断页面按钮权限
export function IsOkButton(name) {
  let isOk =false;
  if(name){
    let menuid =localStorage.getItem('parkmenuid');
    // console.log(menuid);
    if (menuid && menuid.indexOf('%#') > -1) {
      let menuArray = menuid.split("%#");
      if(menuArray.length==2){
        let nowbuttonStr = menuArray[1];
        isOk=nowbuttonStr.indexOf(name)>-1;
      }
    }
  }
  return isOk;
}



// WEBPACK FOOTER //
// ./src/util/util.js